import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IBrandCard } from '../../../types';
import { ImageFallbackDirective } from '../../../image-fallback.directive';
import { RouterLink } from '@angular/router';
import { BucketPipe } from '../../../bucket.pipe';

@Component({
  selector: 'menu-card',
  templateUrl: './menu-card.component.html',
  styleUrls: ['./menu-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageFallbackDirective, RouterLink, BucketPipe],
  host: {
    '[style.--brand-color]': 'brand().color'
  }
})
export class MenuCardComponent {
  brand = input.required<IBrandCard>();

}
